import {omit} from '@coolcolduk/util';
import {User} from '@cp/model';
import {updateDoc, WithFieldValue} from 'firebase/firestore';
import getUserDocRef from './getUserDocRef';

export default async function updateUserDoc(uid: string, data: WithFieldValue<Partial<User>>): Promise<void> {
  const newData = omit(data, ['createdAt', 'id']);
  const ref = getUserDocRef(uid);
  if (Object.keys(newData).length === 0) return;
  await updateDoc(ref, newData);
}
